import * as yup from 'yup';
import {StoredJsonEntry} from './storage';

const schema = yup
  .object({
    token: yup.string().required(),
    expiresAt: yup.string().required(),
    organizationIdentifier: yup.string().required(),
  })
  .required();

export type StoredViewerSession = yup.InferType<typeof schema>;

const STORAGE_KEY = 'viewer-session';

// Treats the last minute of a session's life as expired, so a request is never
// sent with a token about to lapse mid-flight.
const EXPIRY_BUFFER_MS = 60_000;

const entry = new StoredJsonEntry(() => sessionStorage, STORAGE_KEY, schema);

export function getViewerSession(): StoredViewerSession | null {
  return entry.get();
}

export function storeViewerSession(session: StoredViewerSession): void {
  entry.set(session);
}

export function clearViewerSession(): void {
  entry.clear();
}

export function clearViewerSessionIfCurrent(token: string): void {
  entry.clearIf((stored) => stored.token === token);
}

export function clearViewerSessionForOrganization(
  organizationIdentifier: string,
): void {
  entry.clearIf(
    (stored) => stored.organizationIdentifier === organizationIdentifier,
  );
}

export function isViewerSessionExpired(session: StoredViewerSession): boolean {
  const expiresAt = Date.parse(session.expiresAt);
  return (
    !Number.isFinite(expiresAt) || expiresAt - EXPIRY_BUFFER_MS <= Date.now()
  );
}
